import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

interface BatchActionProps {
    children?: React.ReactNode;
    isDisabled?: boolean;
    isActive?: boolean;
    onClickToggleAction?: () => void;
    selectAll?: boolean;
    onClickSelectAll?: (all: boolean) => void;
    selectedCount?: number;
};

const BatchAction: React.FC<BatchActionProps> = (props: BatchActionProps) => {

    const [t] = useTranslation();

    const isDisabled = props.isDisabled ?? false;
    const isActive = props.isActive ?? false;
    const selectAll = props.selectAll ?? false;
    const selectedCount = props.selectedCount ?? 0;

    if (!isActive) {
        return (
            <div className="batch-action batch-action--inactive">
                <button
                    className="batch-action__trigger"
                    onClick={() => props.onClickToggleAction?.()}
                    disabled={isDisabled}
                >
                    <FontAwesomeIcon icon={faLayerGroup} />
                    <span>{t('Batch Action')}</span>
                </button>
            </div>
        );
    }

    return (
        <div className="batch-action batch-action--active">
            <div className="batch-action__header">
                <div className="batch-action__left">
                    <button
                        className={`batch-action__select-all${selectAll ? ' is-checked' : ''}`}
                        onClick={() => props.onClickSelectAll?.(!selectAll)}
                    >
                        <span className={`batch-action__checkbox${selectAll ? ' is-checked' : ''}`}>
                            {selectAll && <FontAwesomeIcon icon={faCheck} />}
                        </span>
                        <span className="batch-action__select-label">{t('Select All')}</span>
                    </button>

                    {selectedCount > 0 && (
                        <span className="batch-action__count">
                            {selectedCount} {t('Batch Action Selected')}
                        </span>
                    )}
                </div>

                <button
                    className="batch-action__cancel"
                    onClick={() => props.onClickToggleAction?.()}
                    disabled={isDisabled}
                >
                    <FontAwesomeIcon icon={faTimes} />
                    <span>{t('Cancel')}</span>
                </button>
            </div>

            <div className="batch-action__content">
                {props.children}
            </div>
        </div>
    );

};

export default React.memo(BatchAction);
